import tables from '../tables';

const $toggleSection = $('.js-toggle-section');
const toggleSectionClass = 'is-active';
const $sectionToggle = $('.js-section-toggle');
const sectionOpenClass = 'section--open';

if ($toggleSection.length > 0) {
  $toggleSection.on('click tap', function click() {
    $(this).toggleClass(toggleSectionClass);
    $sectionToggle.fadeToggle(sectionOpenClass);

    // Reload the tables
    tables.tableResize();
  });
}
